<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <div v-if="msgAlerta" class="info-alert row-space">{{ msgAlerta }}</div>


    <div class="form-edit-page row-start">
        <div class="form-item-char30">
            <label class="label-caption">Opção de Relatório</label>
            <select v-model="opcaoSelecionada">
                <option v-for="opcao in lsOpcoes" :key="opcao.id" :value="opcao.id">{{ opcao.descricao }}</option>
            </select>
        </div>

        <div class="form-item">
            <div v-if="!globalStore.idsim">
                <SimSelect :ckAddTodos="true" v-model:idSelecionado="idSim" />
            </div>
            <div v-else>
                <label class="label-caption">SIM</label>
                <div class="field-label">{{ globalStore.nmsim }}</div>
            </div>
        </div>

        <div class="form-item">
            <EstabelecimentoSelect :ckAddTodos="true" v-model:idSelecionado="idEstabelecimento" />
        </div>

        <button type="button" class="buttom-icon--printer" @click="openReport" />
        <button type="button" class="buttom-icon--close" @click="closePage" />
    </div>
</template>

<script setup>
import { ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { globalStore } from '@/globals';
import EstabelecimentoSelect from '@/components/selects/EstabelecimentoSelect.vue';
import SimSelect from '@/components/selects/SimSelect.vue';

const emit = defineEmits(['close']);
const msgAlerta = ref(null);
const idEstabelecimento = ref(0);
const idSim = ref(0);
const isLoading = ref(false);

const lsOpcoes = ref([
    {id: 'estabelecimentosListagemI', descricao: 'Estabelecimentos'},
    {id: 'estabelecimentos_admin', descricao: 'Estabelecimentos x Gestores'},
    {id: 'estabelecimentos_rt', descricao: 'Estabelecimentos x RT'},
    {id: 'produtos_estabelecimento', descricao: 'Estabelecimentos x Produtos Ativos'},
]);
const opcaoSelecionada = ref('estabelecimentosListagemI');

const closePage = () => {emit('close');}

const openReport = async() => {
    try{
        msgAlerta.value = null;
        isLoading.value = true;
        const dados = {
            nmrelatorio: opcaoSelecionada.value,
            idep: globalStore.idep,
            idestabelecimento: idEstabelecimento.value,
            idsim: globalStore.idsim ?? idSim.value,
            idusuario: globalStore.idusuario
        };
        const response = await Api.genericReport(dados);
        const pdfBlob = new Blob([response], { type: 'application/pdf' });
        const pdfUrl = URL.createObjectURL(pdfBlob);
        window.open(pdfUrl, '_blank');
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value = false;}
}
</script>